import React, { ReactElement } from "react";

export const CreatorCheck = (): ReactElement => {
    return (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <ellipse cx="7" cy="6.98063" rx="6.75" ry="6.73551" fill="#FAE26A"/>
            <path d="M6.29688 10.2077L3.34375 7.12061L3.76562 6.55932L6.15625 8.2432L10.2344 4.17383L10.7969 4.73512L6.29688 10.2077Z" fill="black"/>
        </svg>
    );
  };